import createClass from 'create-react-class'
const React = require('react')

const i18n = require('live/services/i18n')

const ValidationMixin = require('live/components/forms/mixins/validation-mixin')
const ObjectInitializerMixin = require('live/components/forms/mixins/object-initializer')('/rest/extension', {
    type: 'snowflake',
    active: true,
    config: {
        db: '',
        user: '',
        role: '',
        schema: '',
        password: '',
        warehouse: '',
        typeField: '__type',
        enableForInput: true,
        accountIdentifier: '',
    },
    fullQualifier: null,
    qualifier: null,
    status: {}
})

const FormBase = require('live/components/extensions/ui/form')

const FormGroup = require('live/components/forms/ui/form-group')

const Form = createClass({
    mixins: [ObjectInitializerMixin, ValidationMixin],
    validations: {},
    render(): JSX.Element {
        const object = this.state.object
        const config = object.config

        return (
            <FormBase self={this}>
                <div className="form-area">
                    <h3>{i18n('Connection config')}</h3>

                    <FormGroup
                        type="text"
                        label={i18n('Account Identifier')}
                        name="config.accountIdentifier"
                        value={config.accountIdentifier}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.accountIdentifier')}
                        hasFeedback
                        help={this.errorsFor('config.accountIdentifier')}
                    />

                    <FormGroup
                        type="text"
                        label={i18n('User')}
                        name="config.user"
                        value={config.user}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.user')}
                        hasFeedback
                        help={this.errorsFor('config.user')}
                    />

                    <FormGroup
                        type="password"
                        label={i18n('Password')}
                        name="config.password"
                        value={config.password}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.password')}
                        hasFeedback
                        help={this.errorsFor('config.password')}
                    />

                    <FormGroup
                        type="text"
                        label={i18n('Role')}
                        name="config.role"
                        value={config.role}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.role')}
                        hasFeedback
                        help={this.errorsFor('config.role')}
                    />

                    <FormGroup
                        type="text"
                        label={i18n('Warehouse')}
                        name="config.warehouse"
                        value={config.warehouse}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.warehouse')}
                        hasFeedback
                        help={this.errorsFor('config.warehouse')}
                    />

                    <FormGroup
                        type="text"
                        label={i18n('DB')}
                        name="config.db"
                        value={config.db}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.db')}
                        hasFeedback
                        help={this.errorsFor('config.db')}
                    />

                    <FormGroup
                        type="text"
                        label={i18n('Schema')}
                        name="config.schema"
                        value={config.schema}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.schema')}
                        hasFeedback
                        help={this.errorsFor('config.schema')}
                    />
                </div>
            </FormBase>
        )
    }
})

export default Form
